'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * a list of vendor prefixes to use for css-feature testing
 * @type {Array}
 */
var vendorPrefixes = ['webkit', 'moz', 'ms'];

/**
 * tests if a value is supported on a property
 * @param  {String} prop  property to test for value support
 * @param  {String} value unprefixed value to test
 * @return {String|Boolean}       returns the supported value or `false`
 */
var cssSupportsValue = function cssSupportsValue(prop, value) {
  var div = document.createElement('div');
  var values = [value].concat(_toConsumableArray(vendorPrefixes.map(function (prefix) {
    return '-' + prefix + '-' + value;
  })));
  for (var i = 0; i < values.length; i++) {
    div.style[prop] = values[i];
    if (values[i] === div.style[prop]) {
      // value is supported
      div.remove();
      return values[i];
    }
  }
  // no supported value found
  div.remove();
  return false;
};

var position = {
  sticky: cssSupportsValue('position', 'sticky')
};

exports.position = position;
exports.default = { position: position };


//////////////////
// WEBPACK FOOTER
// ./~/react-over-scroll/lib/components/css-supports/index.js
// module id = 457
// module chunks = 35783957827783